module.exports = __webpack_public_path__ + "static/img/dom.aba7b02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/dom.svg
// module id = L5Ck
// module chunks = 0